import React, { useEffect } from 'react';

import { MappingType, RawBlipType } from '../types';
import { useRadarState } from '../stores/radar.state';

interface Props {
  csvFile: string;
  mapping: MappingType<RawBlipType>;
  isCsvString?: boolean;
}

export const AddCSV: React.FC<Props> = ({ csvFile, mapping, isCsvString }) => {
  const {
    processes: { fetchRadarBlips }
  } = useRadarState();

  useEffect(() => {
    fetchRadarBlips(csvFile, mapping, isCsvString);
  }, [csvFile]);

  return <React.Fragment />;
};
